export default defineAppConfig({
  ui: {
    colors: {
      primary: "primary",
      secondary: "secondary",
      neutral: "neutral",
    },

    dashboardSidebar: {
      slots: {
        root: "fixed w-full h-15 min-h-15 bottom-0 left-0 flex overflow-hidden z-50 lg:hidden",
        body: "flex flex-row items-center justify-center overflow-hidden gap-0 p-0.5 m-0",
        content: "",
      },
      variants: {
        side: {
          right: {
            root: "border-r border-default",
          },
        },
        toggleSide: {
          right: {
            toggle: "me-auto",
          },
        },
      },
    },
    dashboardPanel: {
      slots: {
        root: "min-h-[calc(100vh-3.75rem)] h-[calc(100vh-3.75rem)] lg:h-full lg:min-h-full overflow-auto flex-none",
        body: "p-0 sm:p-0 md:p-0 lg:p-0 ",
      },
    },

    icons: {
      chevronLeft: "i-solar-alt-arrow-right-linear",
      chevronRight: "i-solar-alt-arrow-left-linear",
      chevronDoubleLeft: "i-solar-double-alt-arrow-right-linear",
      chevronDoubleRight: "i-solar-double-alt-arrow-left-linear",
      close: "i-solar-close-circle-outline",
      hash: "i-solar-hashtag-outline",
    },
    
    button: {
      slots: {
        base: "cursor-pointer !font-estedad font-bold",
      },
      variants: {
        color:{
          primary: "dark:bg-primary-300 dark:hover:bg-primary-400 dark:text-black [&:disabled]:dark:bg-primary-100",
        },
        variant:{
          ghost: "dark:bg-transparent",
        },
        size: {
          xs: {
            base: "px-4 py-2.5 gap-1.5 text-xs rounded-[0.625rem]",
            leadingIcon: "size-4",
          },
          sm: {
            base: "px-5 py-3 gap-1.5 text-sm rounded-[0.625rem]",
            leadingIcon: "size-5",
          },
          md: {
            base: "px-6 py-3.5 gap-1.5 text-md rounded-[0.75rem]",
            leadingIcon: "size-5.5",
          },
          lg: {
            base: "px-7 py-4 gap-1.5 text-lg rounded-[0.875rem]",
            leadingIcon: "size-6",
          },
          xl: {
            base: "px-8.5 py-5 gap-2.5 text-xl rounded-[1rem]",
            leadingIcon: "size-7",
          },
        },
        block: {
          true: {
            trailingIcon: 'm-0'
          }
        },
      },
      compoundVariants: [
        {
          color: 'primary',
          variant: 'soft',
          class: 'dark:bg-neutral-600 dark:hover:bg-neutral-500 dark:text-black focus-visible:bg-neutral-600'
        },
      ]
    },

    switch: {
      slots: {
        root: "items-center",
        base: "cursor-pointer",
        label: "font-estedad font-bold",
        description: "font-regular font-estedad!",
      },
      variants: {
        size: {
          xl: {
            wrapper: "text-lg"
          }
        }
      }
    },

    formField: {
      slots: {
        label: "mb-1",
        description: "text-muted !font-estedad font-regular",
        hint: "text-muted !font-estedad font-regular",
        help: "mt-2 text-muted !font-estedad font-regular",
      },
      variants: {
        size: {
          xs: {
            label: "text-xs font-pinar !font-hbold",
            description: "text-xs",
            hint: "text-xs",
            help: "text-xs",
          },
          sm: {
            label: "label ",
            description: "sub-label",
            hint: "sub-label",
            help: "sub-label",
          },
          md: {
            label: "h6 ",
            description: "text-sm",
            hint: "text-sm",
            help: "text-sm",
          },
          lg: {
            label: "h5 ",
            description: "small",
            hint: "small",
            help: "small",
          },
          xl: {
            label: "h4 ",
            description: "sub2",
            hint: "sub2",
            help: "sub2",
          },
        },
      },
    },

    input: {
      slots: {
        base: "!font-estedad font-regular",
      },
      variants: {
        size: {
          xs: {
            base: "px-4 py-2.5 rounded-[0.625rem] text-sm",
          },
          sm: {
            base: "px-5 py-3 rounded-[0.625rem] text-sm",
          },
          md: {
            base: "px-6 py-3.5 rounded-[0.75rem] text-base",
          },
          lg: {
            base: "px-7 py-4 rounded-[0.875rem] text-lg",
          },
          xl: {
            base: "px-8.5 py-5 rounded-[1rem] text-xl",
          },
        },
      },
    },

    textarea: {
      slots: {
        base: "!font-estedad font-regular",
      },
      variants: {
        size: {
          xs: {
            base: "px-4 py-2.5 rounded-[0.625rem] text-xs",
          },
          sm: {
            base: "px-5 py-3 rounded-[0.625rem] text-sm",
          },
          md: {
            base: "px-6 py-3.5 rounded-[0.75rem] text-base",
          },
          lg: {
            base: "px-7 py-4 rounded-[0.875rem] text-lg",
          },
          xl: {
            base: "px-8.5 py-5 rounded-[1rem] text-xl",
          },
        },
      },
    },

    select: {
      slots: {
        base: "!font-estedad font-regular",
        leading: "!relative !p-0",
        item: "cursor-pointer",
      },
      variants: {
        size: {
          xs: {
            base: "!pr-4 !py-2.5 rounded-[0.625rem] text-xs",
            trailing: "pl-4",
            group: "!px-4 !py-2.5",
          },
          sm: {
            base: "!pr-5 py-3 rounded-[0.625rem] text-sm",
            trailing: "pl-5",
            group: "!px-5 !py-3",
          },
          md: {
            base: "!pr-6 py-3.5 rounded-[0.75rem] text-base",
            trailing: "pl-6",
            group: "!px-6 !py-3.5",
          },
          lg: {
            base: "!pr-7 py-4 rounded-[0.875rem] text-lg",
            trailing: "pl-7",
            group: "!px-7 !py-4",
          },
          xl: {
            base: "!pr-8.5 py-5 rounded-[1rem] text-xl",
            trailing: "pl-8.5",
            group: "!px-8.5 !py-5",
          },
        },
      },
    },

    modal: {
      slots: {
        content: "p-4 lg:p-8 !rounded-[1rem] divide-y-0",
        header: "!p-0",
        footer: "!p-0",
        body: "!p-0",
      },
    },

    checkbox: {
      slots: {
        base: "cursor-pointer",
        label: "font-pinar font-bold",
        description: "font-regular font-estedad!",
      },
      variants: {
        size: {
          xs: {
            base: "w-[1.125rem] h-[1.125rem] rounded-[0.375rem]",
            label: "text-xs",
            description: "text-xs",
          },
          sm: {
            base: "w-[1.375rem] h-[1.375rem] rounded-[0.5rem]",
            label: "text-sm",
            description: "text-xs",
            icon: "w-[1.125rem] h-[1.125rem]"
          },
          md: {
            base: "w-[1.625rem] h-[1.625rem] rounded-[0.625rem]",
            label: "text-md",
            description: "text-sm",
            icon: "w-[1.375rem] h-[1.375rem]"
          },
          lg: {
            base: "w-[1.875rem] h-[1.875rem] rounded-[0.625rem]",
            label: "text-lg",
            description: "text-md",
            icon: "w-[1.625rem] h-[1.625rem]"
          },
          xl: {
            base: "w-[2.125rem] h-[2.125rem] rounded-[0.625rem]",
            label: "text-xl",
            description: "text-lg",
            icon: "w-[1.875rem] h-[1.875rem]"
          },
        },
      },
    },

    radioGroup: {
      slots: {
        base: "cursor-pointer",
        label: "font-pinar font-bold",
        description: "font-regular font-estedad!",
      },
      variants: {
        size: {
          xs: {
            base: "w-[1.125rem] h-[1.125rem] rounded-full",
            label: "text-xs",
            description: "text-xs",
          },
          sm: {
            base: "w-[1.375rem] h-[1.375rem] rounded-full",
            label: "text-sm",
            description: "text-xs",
          },
          md: {
            base: "w-[1.625rem] h-[1.625rem] rounded-full",
            label: "text-md",
            description: "text-sm",
          },
          lg: {
            base: "w-[1.875rem] h-[1.875rem] rounded-full",
            label: "text-lg",
            description: "text-md",
          },
          xl: {
            base: "w-[2.125rem] h-[2.125rem] rounded-full",
            label: "text-xl",
            description: "text-lg",
          },
        },
      },
    },

  },
});
